import React, { useEffect, useState } from "react";
import ogimage from "../assets/Images/ogImages/OG_DigirytePods.jpg";

import { BASE_SITE_URL } from "../shared/constants.js";
import Layout from "../components/layouts/layout.js";
import MarktingHeroBanner from "../components/marketing/marktingHeroBanner.jsx";
import TestimonialsSection from "../components/marketing/testimonialsSection.jsx";
import DataService from "../services/api/data_services.js";
import ArticleCard from "../components/featuredInsights/articleCard.jsx";
import AwsSaving from "../components/marketing/awsSaving.jsx";
import ImageSlide from "../components/marketing/imageSlide.jsx";
import NewCtaSection from "../components/CTASection/newCtaSection.jsx";
import { Link, navigate } from "gatsby";
import RevealAnimation from "../components/RevealAnimation/index.jsx";
import DigiRyteLogo from "../assets/Images/Footer/updated/digiryte-logo.svg";
import { Formik } from "formik";
import OurOffering from "../components/servicesSection/ourOffering.jsx";
import Infoview from "../templates/InfoView/index.jsx";

import BannerBgImage from "../assets/Images/services/consult-banner.png";
import CTAIMAGE1 from "../assets/Images/Clutch/Cta/phone-contact.png";
import ConsultImage from "../assets/Images/Homepage/FullStackExpertise/audit.png";
import CloudMigration from "../assets/Images/services/audit/cloud-Migration.png";
import CloudSecurity from "../assets/Images/services/audit/cloud-Security.png";
import CodeUXAudit from "../assets/Images/services/audit/Code-UXAudit.png";
import ComplianceAudit from "../assets/Images/services/audit/Compliance-Audit.png";
import CostAnalysis from "../assets/Images/services/audit/Cost-Analysis.png";
import CRESTPenTest from "../assets/Images/services/audit/CREST-PenTest.png";
import EfficiencyAudit from "../assets/Images/services/audit/Efficiency-Audit.png";
import Innovation from "../assets/Images/services/audit/Innovation.png";
import RiskAssessment from "../assets/Images/services/audit/Risk-Assessment.png";
import TechStackReview from "../assets/Images/services/audit/Tech-Stack-Review.png";
import TechTalent from "../assets/Images/services/audit/Tech-Talent.png";
import VendorAudit from "../assets/Images/services/audit/Vendor-Audit.png";
import AuditServiceForm from "../components/marketing/auditServicesForm.jsx";
import "../components/marketing/awsCreditsr.scss";

const Marketing = () => {
  const [articleData, setArticleData] = useState([]);
  const [location, setLocation] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [clientStoryData, setClientStoryData] = useState([]);
  const [clientStoryRawData, setClientStoryRawData] = useState([]);
  const urlPathname = typeof window !== "undefined" ? window.location.href : "";

  useEffect(() => {
    DataService.getData(`https://ipapi.co/json/`).then((res) =>
      setLocation(res.city)
    );
    DataService.getData(
      `/admin/api/post?limit=3&page=1&page_id=1&type=Client Story&component=mini_view`
    ).then((response) => {
      setClientStoryData([...clientStoryData, ...response.data]);
      setClientStoryRawData(response);
    });
  }, []);

  useEffect(() => {
    DataService.getData(
      `/admin/api/post?limit=3&page=$1&page_id=1&type=Article&component=mini_view`
    ).then((response) => {
      setArticleData([...articleData, ...response.data]);
    });
  }, []);

  const handleSubmit = (formData) => {
    setIsLoading(true);
    DataService.postData(
      `admin/api/sendmail`,
      { ...formData, location: location },
      {
        type: "contactus_new",
      }
    )
      .then((response) => {
        if (typeof window !== `undefined`) {
          navigate(`/thank-you-contact`);
        }
      })
      .catch((error) => {
        // setSnackbarStatus(true);
        // setSnackbarMessage(error.message);
        // setTimeout(() => {
        //   setSnackbarStatus(false);
        //   setSnackbarMessage("");
        // }, 10000);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const ourPolicy = [
    {
      title: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      title: "Cookie Policy",
      link: "/cookie-policy",
    },
  ];

  const listItem = [
    "Security vulnerabilities keep you up at night.",
    "Pages load slowly and users bounce.",
    "Cloud bills spiral without warning.",
    "UX friction stalls conversions & revenue.",
  ];

  const complianceOfferList = [
    {
      label: "Technology Stack Audit",
      details:
        "Review your existing tech stacks, architecture, performance, and maintainability, highlighting modernization and optimisation opportunities.",
      image: TechStackReview,
    },
    {
      label: "Cloud Migration Readiness Assessment",
      details:
        "Evaluate your infrastructure, applications, and processes against migration best practices, defining readiness gaps and a pragmatic transition roadmap.",
      // buttonName: "Ask About Our Vendor Capability & Compliance Audit",
      image: CloudMigration,
    },

    {
      label: "Code & UX Audit",
      details:
        "Examine your code quality and user experience, pinpointing technical debt, usability issues, and design inconsistencies to boost satisfaction.",
      image: CodeUXAudit,
    },
  ];

  const complianceOfferData = [
    {
      label: "Innovation Potential Assessment",
      details:
        "Assess your current solutions innovation readiness, identifying opportunities to integrate emerging technologies and streamline processes.",
      image: CRESTPenTest,
    },
    {
      label: "Pre-Investment Risk Assessment",
      details:
        "Evaluate technical, operational, and market risks prior to investment, providing comprehensive insights to inform due diligence and strategy.",
      image: VendorAudit,
    },
    {
      label: "Tech & Talent Due Diligence",
      details:
        "Assess your technology capabilities and team competencies, identifying skill gaps, organizational strengths, and readiness for strategic initiatives and growth.",
      image: ComplianceAudit,
    },
  ];

  const platformPerformanceOfferList = [
    {
      label: "Cost Optimisation Analysis",
      details:
        "Analyse your cloud and application spend, uncover inefficiencies, and recommend strategies for cost reduction while maintaining performance.",
      image: CostAnalysis,
    },
    {
      label: "Performance & Efficiency Audit",
      details:
        "Benchmark your applications under load, identify bottlenecks, and recommend optimizations to improve responsiveness, scalability, and utilization.",
      image: EfficiencyAudit,
    },
  ];

  const productOfferList = [
    {
      label: "Vendor Capability & Compliance Audit",
      details:
        "Evaluate your vendor’s technical capabilities and regulatory compliance, identifying gaps by ensuring alignment with your security and quality standards.",
      image: VendorAudit,
    },
    {
      label: "Cloud Security Assessment",
      details:
        "Assess your cloud environment’s security posture, identifying vulnerabilities and misconfigurations, and recommend remediation measures.",
      image: CloudSecurity,
    },
    {
      label: "Compliance Audit",
      details:
        "Analyse your systems against industry regulations and standards, highlighting compliance gaps and recommending controls to mitigate risk.",
      image: ComplianceAudit,
    },
    {
      label: "CREST Penetration Testing",
      details:
        "Conduct rigorous CREST-standard security testing to identify exploitable vulnerabilities, validating defense mechanisms and strengthening posture.",
      image: CRESTPenTest,
    },
  ];

  const InfoviewDataAskOurClients = {
    route: "/clients",
    width: "112px",
    customClassName: "info-view-resize-btn",
    color: "primary",
    variant: "contained",
    tooltip: "no",
    tag: "h3",
    // InfoviewButtonLabel: "Learn More",
    InfoviewTitle: (
      <div className="">
        See why our clients believe <br />{" "}
        <span className="red-line3letter red-3letter-mbl">we</span> are their
        ryte partners <br />{" "}
        {/* <span className="red-line3letter">Ask</span> Our Clients */}
      </div>
    ),
    // InfoviewContent: (
    //   <>
    //     Our strong agile team empowers start-ups and entrepreneurs with
    //     customised solutions that transform their vision into great products for
    //     the market. With our extensive experience in software development,
    //     location-based mobile app development, and open-source products, we have
    //     helped hundreds of customers utilise technology and future-proof their
    //     business continuously. Find out how we are creating ground-breaking
    //     digital solutions and helping launch successful businesses across the
    //     UK.
    //   </>
    // ),
  };

  return (
    <Layout
      isIndexPage={false}
      isLandingPage={true}
      showFixedButton={false}
      seo={{
        title: "Audit Services | DigiRyte",
        ogtitle: "Audit Services | DigiRyte",
        description:
          "DigiRyte assists in hiring, managing, and implementing all the relevant human resource functions for building and scaling reliable and dynamic remote teams.",
        ogimage: ogimage,
        ogurl: `${BASE_SITE_URL}/digiryte-pods`,
        keywords:
          "remote teams, hiring, managing, human resources, scaling teams, dynamic teams",
      }}
    >
      <MarktingHeroBanner
        title={
          <>
            Eliminate risk & accelerate growth with a{" "}
            <span className="text-gray-dark">360° Digital Product Audit.</span>
          </>
        }
        subTitle={
          <>
            Free expert review & action‑ready report in just{" "}
            <b className="text-black-dark">5 business days.</b>
          </>
        }
        ctaTitle1="Get My Free Audit Report"
      />
      <AuditServiceForm
        handelSubmit={handleSubmit}
        listItem={listItem}
        // title={<>Pain Points</>}
      />
      <ImageSlide />

      <div className="">
        <div className="body-container">
          <OurOffering
            title="Our Solution"
            details="DigiRyte's senior architects, security engineers and UX specialists deep‑dive into your codebase, infrastructure and user journeys. You receive a priority‑ranked improvement roadmap you can action immediately-whether you build with us or not."
            CardListData={productOfferList}
            pageName="audit"
            sectionTitle="Audit Categories & Services"
            listTitle="A. Security & Compliance Audits"
            hideCTA={true}
          />
          <OurOffering
            CardListData={platformPerformanceOfferList}
            pageName="audit"
            listTitle="B. Cost & Performance Audits"
            hideCTA={true}
          />
          <OurOffering
            CardListData={complianceOfferList}
            pageName="audit"
            listTitle="C. Technology & Modernisation Audits"
            hideCTA={true}
          />
          <OurOffering
            CardListData={complianceOfferData}
            pageName="audit"
            listTitle="D. Strategic & Investment Audits"
            hideCTA={true}
          />
        </div>
      </div>

      {/* <MatterSection /> */}
      {/* <ApplyWithDigiryte handelSubmit={handleSubmit} /> */}
      {/* <Additional /> */}
      <TestimonialsSection />

      {/* <div className="mt-70 article_row-center">
        <RevealAnimation animation="slide-left">
          <h2 className="testimonials-section__title">
            Read more
            <span className="text-gray-dark"> about DigiRyte</span>
          </h2>
        </RevealAnimation>
        {articleData && articleData.length > 0 && (
          <div className="mt-50">
            <ArticleCard title="" isDisableLink miniviewData={articleData} />
          </div>
        )}
      </div> */}
      <div className=" mt-70">
        <RevealAnimation animation="fade" className="">
          <Infoview InfoviewData={InfoviewDataAskOurClients} />
        </RevealAnimation>

        {clientStoryData && clientStoryData.length > 0 && (
          <div className="mt-50">
            <ArticleCard miniviewData={clientStoryData} title="Client Story" />
            {/* <Miniview
              miniviewData={clientStoryData}
              navigateComponent={<LeftGrid />}
            /> */}
          </div>
        )}
        {/* {clientStoryRawData.has_more && (
          <div style={{ width: "100%", textAlign: "center" }}>
            <div
              onMouseEnter={toggleHover}
              onMouseLeave={toggleHover}
              className="mt-60"
              role="presentation"
              style={{ display: "inline-block" }}
            >
              <Button
                icon={
                  <img
                    className="effect-btn-svgicon"
                    src={!isHover ? RightArrow : RightArrowWhite}
                    alt="Load More"
                  />
                }
                customClassName="info-view-resize-btn bg-white"
                color="primary"
                variant="outlined"
                routepath="/clients"
                label="More Client Stories"
                tip="More Client Stories"
                tooltip="no"
              />
            </div>
          </div>
        )} */}
      </div>
      <div className="about-cta-section">
        <NewCtaSection
          title="Ready to secure & scale your product?"
          buttonLabel="Book My Free Audit"
          pagePath="#contact-aws-saving"
        />
      </div>
      <div className="footer-bottom-wrap mb-30">
        <div className="body-container">
          <div className="footer-bottom-inner-wrap">
            <div className="footer-bottom-container">
              <div className="footer-logo-wrap">
                <img src={DigiRyteLogo} alt="DigiRyte" />
              </div>
              <div className="footer-bottom-menu">
                {ourPolicy.map((item, index) => (
                  <Link
                    key={index}
                    className="footer-bottom-item"
                    to={item.link}
                  >
                    <p>{item.title}</p>
                  </Link>
                ))}
              </div>
            </div>
            <div className="footer-bottom-container">
              <div className="footer-copyright">
                All rights reserved. © {new Date().getFullYear() - 1} -{" "}
                {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Marketing;
